<template>
	<my-popup destroy-on-close :update="false" :visible.sync="visible" :modal-style="modalStyle">
        <div class="loading-container">
            <div class="loading-icon">
            	<i></i>
            	<i></i>
            	<i></i>
            	<i></i>
            	<i></i>
            	<i></i>
            </div>
            <div class="loading-text" v-if="title" v-text="title"></div>
        </div>
	</my-popup>
</template>

<script>
    import getText from '../getText.js'
	import myPopup from '../../components/my-popup.vue'
	export default {
		name: 'loading',
		data() {
			return {
				text: '',
				myVue: null,
				visible: false
			}
		},
		methods: {
			show(text = '', visible = false, myVue) {
				this.text = '';
				this.myVue = myVue;
				this.visible = visible;
				if (visible) {
					this.text = text;
				}
			}
		},
		computed: {
			title() {
				return getText(this, this.text, '', this.text);
			},
			modalStyle() {
				const url = './lodingbg.jpg'
				const config = Object.create(null);
				config['zIndex'] = 9995;
				config['backgroundColor'] = 'rgba(0, 0, 0, 0.5)';
				config['backgroundImage'] = 'url(' + url + ')';
				config['backgroundRepeat'] = 'no-repeat';
				config['backgroundSize'] = 'cover';
				return config;
			}
		},
		components: {
			'my-popup': myPopup
		}
	}
</script>

<style scoped lang="less">
    .loading-container{
        padding: 0;
        max-width: 100vw;
        max-height: 100vh;
        box-shadow: none;
        border-radius: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: transparent;
        .loading-icon{
        	width: 100px;
        	height: 100px;
        	margin: 0 auto;
        	position: relative;
        	i{
        		display: block;
        		position: absolute;
        		top: 50%;
        		left: 50%;
        		width: 60%;
        		height: 4%;
        		transform-origin: 50% 50%;
        		background-color: transparent;
        		&::before, &::after{
        			content: '';
        			display: block;
        			position: absolute;
        			top: 0;
        			width: 27%;
        			height: 100%;
        			border-radius: 60px;
        			background-color: #FFFFFF;
        		}
        		&::before{
        			left: 0;
        		}
        		&::after{
        			right: 0;
        		}
        		&:nth-child(1){
        			transform: translate(-50%, -50%) rotate(270deg);
        		}
        		&:nth-child(2){
        			transform: translate(-50%, -50%) rotate(300deg);
        		}
        		&:nth-child(3){
        			transform: translate(-50%, -50%) rotate(330deg);
        		}
        		&:nth-child(4){
        			transform: translate(-50%, -50%) rotate(0deg);
        		}
        		&:nth-child(5){
        			transform: translate(-50%, -50%) rotate(30deg);
        		}
        		&:nth-child(6){
        			transform: translate(-50%, -50%) rotate(60deg);
        		}
        		&:nth-child(1)::before{
        			animation: loading 1.2s linear 0s infinite;
        		}
        		&:nth-child(2)::before{
        			animation: loading 1.2s linear 0.1s infinite;
        		}
        		&:nth-child(3)::before{
        			animation: loading 1.2s linear 0.3s infinite;
        		}
        		&:nth-child(4)::before{
        			animation: loading 1.2s linear 0.4s infinite;
        		}
        		&:nth-child(5)::before{
        			animation: loading 1.2s linear 0.5s infinite;
        		}
        		&:nth-child(6)::before{
        			animation: loading 1.2s linear 0.6s infinite;
        		}
        		&:nth-child(1)::after{
        			animation: loading 1.2s linear 0.7s infinite;
        		}
        		&:nth-child(2)::after{
        			animation: loading 1.2s linear 0.8s infinite;
        		}
        		&:nth-child(3)::after{
        			animation: loading 1.2s linear 0.9s infinite;
        		}
        		&:nth-child(4)::after{
        			animation: loading 1.2s linear 1s infinite;
        		}
        		&:nth-child(5)::after{
        			animation: loading 1.2s linear 1.1s infinite;
        		}
        		&:nth-child(6)::after{
        			animation: loading 1.2s linear 1.2s infinite;
        		}
        	}
        	@keyframes loading{
        		from{
        			opacity: 0;
        		}
        		to{
        			opacity: 1;
        		}
        	}
        }
        .loading-text{
        	color: #FFFFFF;
        	margin: 0 auto;
        	font-size: 1.6rem;
        	line-height: 2rem;
        	text-align: center;
        	width: calc(100vw - 60px);
        }
    }
</style>
